import React from 'react'
import InputKeyValue from '../shared/InputKeyValue'
import { prefix } from '../normalizer'

const tRegister = prefix('gamification2026.register')

const StoreDetailsForm = ({ required, onChangeStoreDetails }) => {
  return (
    <div className="register__section">
      <h3 className="register__section-title">{tRegister('store-details-title')}</h3>
      <div className="register__row">
        <InputKeyValue
          title={tRegister('store-name')}
          placeholder={tRegister('store-name-placeholder')}
          name="name"
          type="text"
          required={required}
          onChange={onChangeStoreDetails}
        />
        <InputKeyValue
          title={tRegister('store-insignia')}
          placeholder={tRegister('store-insignia-placeholder')}
          name="insignia"
          type="text"
          required={required}
          onChange={onChangeStoreDetails}
        />
      </div>
      <div className="register__row">
        <InputKeyValue
          title={tRegister('zipcode')}
          placeholder={tRegister('zipcode-placeholder')}
          name="zip_code"
          type="text"
          required={required}
          onChange={onChangeStoreDetails}
        />
        <InputKeyValue
          title={tRegister('city')}
          placeholder={tRegister('city-placeholder')}
          name="city"
          type="text"
          required={required}
          onChange={onChangeStoreDetails}
        />
      </div>
    </div>
  )
}

export default StoreDetailsForm
